import { BASE_URL } from "../utils/constants";
import handler from "../utils/handler";
import { clearAllLocalStorage } from "../utils/localStorageManager";

export const GetAdminData = async(value) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }

        let response = await fetch(`${BASE_URL}/core/settings/admin/token`, {
            method: "GET",
            headers,
           
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        let result = handler(response)
        return result
       
    } catch (e) {
        throw e;
    }
}

export const UpdateAdminData = async(value) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }

        let response = await fetch(`${BASE_URL}/core/settings`, {
            method: "PUT",
            headers,
            body: JSON.stringify(value)
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        
        return response
       
    } catch (e) {
        throw e;
    }
}


export const UpdatePasswordData = async(value) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }
        
        let response = await fetch(`${BASE_URL}/core/settings/admin/reset-password`, {
            method: "POST",
            headers,
            body: JSON.stringify(value)
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        
        return response
       
    } catch (e) {
        throw e;
    }
}